



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Badges from './Badges.vue';
import { convertToHtmlHelper } from '@/heplers';
import { ChildMethod } from '@/templates/NewRoutes';

@Component({
  components: {
    Badges,
  },
})
export default class ApiRequestReturnParams extends Vue {
  @Prop(Array) parameters: ChildMethod[];

  convertToHtml(mdString: string) {
    return convertToHtmlHelper(mdString);
  }
}
